// extracted by mini-css-extract-plugin
export var cardIcon = "_7b-5";
export var checkboxCard = "_7b-0";
export var checkboxCardSelected = "_7b-4";
export var disabled = "_7b-2";
export var interactive = "_7b-1";
export var outerBorder = "_7b-3";
export var spacerMedium = "_7b-8";
export var spacerSmall = "_7b-7";
export var spacerXsmall = "_7b-6";